<template>
  <q-form ref="editForm">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <!-- 공정사고 기본정보 -->
      <c-card title="LBL0002372" class="cardClassDetailInfo">
        <template slot="card-button">
          <q-btn-group outline >
            <!-- <c-btn v-if="!disabled" label="LBLREMOVE" :editable="editable" icon="delete_forever" @btnClicked="remove" /> -->
            <font v-if="(standardInfo.reportTypeCd === 'IRC0000005' || standardInfo.reportTypeCd === 'IRC0000001')" color="#C10015">
              <!-- ※ 종결처리시 상단탭에서 중간, 최종보고를 선택하여 추가를 할 수 있습니다. -->
              {{setMessage('MSG0000705')}}
            </font>
            <!-- 종결처리 -->
            <c-btn 
              v-show="!disabled" 
              :isSubmit="isComplete"
              :url="completeUrl"
              :param="accidentInfo"
              :mappingType="completeType"
              label="LBL0002374" 
              icon="check"
              @beforeAction="completeAccident"
              @btnCallback="completeCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-3">
            <!-- 사고번호 -->
            <c-label-text title="LBL0002305" :value="standardInfo.accidentNo"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 사고명 -->
            <c-label-text title="LBL0002306" :value="standardInfo.accidentName"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 사고종류 -->
            <c-label-text title="LBL0002301" :value="standardInfo.accidentKindName"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 사고등급 -->
            <c-label-text title="LBL0002300" :value="standardInfo.accidentGradeName"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 발생일시 -->
            <c-label-text title="LBL0002309" :value="standardInfo.occurrenceDate"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 발생부서 -->
            <c-label-text title="LBL0002302" :value="standardInfo.occurrenceDeptName"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 발생형태 대분류 -->
            <c-label-text title="LBL0002375" :value="standardInfo.occurrenceModeLargeName"></c-label-text>
          </div>
          <div class="col-3">
            <!-- 발생형태 중분류 -->
            <c-label-text title="LBL0002376" :value="standardInfo.occurrenceModeSmallName"></c-label-text>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <!-- 계획 및 담당자의견 -->
      <c-card title="LBL0002391" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline>
            <!-- 저장 -->
            <c-btn
              v-if="!disabled"
              :url="updateUrl"
              :isSubmit="isSave"
              :param="accidentInfo"
              mappingType="PUT"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveAccident"
              @btnCallback="saveCallback" 
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
            <!-- 단기계획 -->
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="5"
              label="LBL00001556"
              name="shortPlan"
              v-model="accidentInfo.shortPlan">
            </c-textarea>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <!-- 중장기 계획 -->
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="5"
              label="LBL00001557"
              name="longPlan"
              v-model="accidentInfo.longPlan">
            </c-textarea>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <!-- 담당자 의견 -->
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="5"
              label="LBL00001558"
              name="managerOpinion"
              v-model="accidentInfo.managerOpinion">
            </c-textarea>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <!-- 개선 목록 -->
      <c-table
        ref="tableImpr"
        title="개선 목록"
        :columns="gridImpr.columns"
        :data="accidentInfo.accidentImproveModelList"
        :gridHeight="gridImpr.height"
        :merge="gridImpr.merge"
        selection="multiple"
        rowKey="causesNo"
        :usePaging="false"
        :isExcelDown="false"
        :filtering="false"
        :columnSetting="false"
        :editable="editable && !disabled"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <!-- 추가 -->
            <c-btn v-if="editable && !disabled" label="LBLADD" :showLoading="false"  icon="add" @btnClicked="add" />
            <!-- 저장 -->
            <c-btn
              v-if="editable && !disabled && accidentInfo.accidentImproveModelList.length > 0"
              :url="updateCauseUrl"
              :isSubmit="isSave2"
              :param="accidentInfo.accidentImproveModelList"
              mappingType="PUT"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveAccident2"
              @btnCallback="saveCallback" 
            />
            <c-btn v-if="editable && !disabled && accidentInfo.accidentImproveModelList.length > 0" label="LBLREMOVE" :showLoading="false" icon="remove" @btnClicked="removeImpr" />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name==='customCol'">
            <component
              :is="imprComponent"
              :col="col"
              :props="props"
              :inputEditable="editable&&!disabled"
              :isImmShow="true"
              :requestContentsCols="requestContentsCols"
              tableKey="causesNo"
              ibmTaskTypeCd="ITT0000040"
              ibmTaskUnderTypeCd="ITTU000065"
              @imprChange="imprChange"
            />
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import mixinConvert from '@/js/mixin-template-convert'
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'accident-cause-prevention',
  mixins: [mixinConvert],
  props: {
    param: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        reportName: '',
        count: 0,
      }),
    },
  },
  data() {
    return {
      editable: true,
      standardInfo: {
        accidentNo: '',
        accidentName: '',
        accidentKindName: '',
        accidentGradeName: '',
        occurrenceDate: '',
        occurrenceDeptName: '',
        occurrenceModeLargeName: '',
        occurrenceModeSmallName: '',
        accidentStatusCd: '',
      },
      accidentInfo: {
        shortPlan: '',
        longPlan: '',
        managerOpinion: '',
        accidentStautsCd: '',

        accidentImproveModelList: [],
      },
      gridImpr: {
        columns: [
          {
            required: true,
            name: 'causeTypeCd',
            field: 'causeTypeCd',
            // 원인구분
            label: 'LBL00001560',
            align: 'center',
            style: 'width:15%',
            type: 'select',
            comboItems: [
              { code: 'ICDC000001', codeName: '기술적' },
              { code: 'ICDC000002', codeName: '교육적' },
              { code: 'ICDC000003', codeName: '관리적' },
            ],
            sortable: false,
          },
          {
            required: true,
            name: 'accidentCause',
            field: 'accidentCause',
            // 사고원인
            label: 'LBL00001561',
            align: 'left',
            type: 'text',
            style: 'width:50%',
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            // 개선진행
            label: 'LBL00001562',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                // 개선번호/진행상태
                label: 'LBLIMPRNO_PROGRESS',
                align: 'center',
                style: 'width:15%',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improvingMeasures',
                field: 'improvingMeasures',
                // 개선대책
                label: 'LBL00001563',
                align: 'left',
                style: 'width:20%',
                type: 'text',
                sortable: false
              },
            ]
          },
        ],
        
        data: [],
        height: '315px'
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      colorItems: [],
      requestImprRow: null,
      imprData: null,
      completeUrl: 'transactionConfig.sop.iim.accident.process.prevention.update.url',
      updateUrl: 'transactionConfig.sop.iim.accident.process.prevention.update.url',
      updateCauseUrl: 'transactionConfig.sop.iim.accident.process.prevention.update.cause.url',
      completeType: 'PUT',
      deleteUrl: '',
      searchUrl: '',
      isComplete: false,
      isSave: false,
      isSave2: false,
    };
  },
  computed: {
    disabled() {
      return this.param.stepCd === 'ISPC000005'
    },
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['accidentCause'];
    },
    // 개선요청 Component
    imprComponent() {
      let components = () => import(`${'@/pages/common/ibm/tableImpr.vue'}`);
      return components;
    },
  },
  watch: {
    'param.count'() {
      this.getStdInfo();
      this.getDetail();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.getUrl = selectConfig.sop.iim.accident.process.get.url;
      this.getInfoUrl = selectConfig.sop.iim.accident.process.prevention.get.url;
      this.updateUrl = transactionConfig.sop.iim.accident.process.prevention.update.url
      this.updateCauseUrl = transactionConfig.sop.iim.accident.process.prevention.update.cause.url
      this.deleteUrl = transactionConfig.sop.iim.accident.process.prevention.delete.url
      
      this.getStdInfo();
      this.getDetail();
    },
    getStdInfo() {
      if (this.param.iimAccidentId) {
        this.$http.url = this.$format(this.getUrl, this.param.iimAccidentId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.standardInfo = _result.data;
          this.updateMode = true;
        },);
      }
    },
    getDetail() {
      if (this.param.iimAccidentId) {
        this.$http.url = this.$format(this.getInfoUrl, this.param.iimAccidentId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.accidentInfo = _result.data;
          this.updateMode = true;
        },);
      }
    },
    // 개선창 닫기 후
    imprChange() {
      this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
    },
    saveAccident() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.accidentInfo.regUserId = this.$store.getters.user.userId
              this.accidentInfo.chgUserId = this.$store.getters.user.userId
              
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveAccident2() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          let isConti = true;
          let checkItem = ['causeTypeCd', 'accidentCause']
          this.$_.forEach(this.accidentInfo.accidentImproveModelList, item => {
            this.$_.forEach(checkItem, check => {
              if (!item[check]) {
                isConti = false;
                return false;
              }
            })
          });
          if (!isConti) {
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              // 필수 입력값을 입력해 주세요. [원인구분, 사고원인]
              message: 'MSG0000431',
              type: 'warning', // success / info / warning / error
            });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',
              message: 'MSGSAVE', // 저장하시겠습니까?
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.accidentInfo.regUserId = this.$store.getters.user.userId
                this.accidentInfo.chgUserId = this.$store.getters.user.userId
                this.isSave2 = !this.isSave2;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        }else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    add() {
      this.accidentInfo.accidentImproveModelList.splice(0, 0, {
        iimAccidentId: this.param.iimAccidentId,
        causesNo: uid(),
        causeTypeCd: null,
        accidentCause: '',
        improvingMeasures: '',
        sopImprovementIds: '', 
        ibmStepNames: '', 
        editFlag: 'C',
      })
    },
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(transactionConfig.sop.iim.accident.process.delete.url, this.param.iimAccidentId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            this.$emit('emitStep', {
              name: 'closePopup',
              param: {},
            })
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    removeImpr() {
      let selectData = this.$refs['tableImpr'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$refs['tableImpr'].$refs['compo-table'].clearSelection();
              this.getDetail();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    completeAccident() {
      this.completeUrl = this.updateUrl;
      this.completeType = 'PUT';
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSG0000707', // 종결처리 하시겠습니까?(저장과 함께 종결처리 됩니다.)
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.accidentInfo.accidentStatusCd = 'ISPC000005'
          this.accidentInfo.regUserId = this.$store.getters.user.userId
          this.accidentInfo.chgUserId = this.$store.getters.user.userId
          
          this.isComplete = !this.isComplete;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.accidentInfo.accidentStatusCd) {
        this.$emit('emitStep', {
          name: 'currentStep',
          param: this.accidentInfo.accidentStatusCd 
        })
        this.$emit('emitStep', {
          name: 'setReportTab',
          param: { stepCd: this.accidentInfo.accidentStatusCd,
                   iimAccidnetId: this.param.iimAccidentId  },
        })
      }
    },
  }
};
</script>
